import { Space, Spin } from "antd";
import React from "react";
import { withRouter } from "react-router";
import { apiCallPost } from "../fns/util";
import VideoSubmissionForm from "./Video";

class PublicVideoComponent extends React.Component {
  state = {
    isLoading: true,
    notUploaded: false,
    videoLinkUrl: "",
  };
  componentDidMount() {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        this.viewVideoSubmission();
      }
    );
  }
  viewVideoSubmission = async () => {
    try {
      let res = await apiCallPost(
        "NOT_AUTHED",
        "/conference2023/viewVideoSubmission",
        {
          submissionId: this.props.match.params.id,
        }
      );

      if (res) {
        if (res.subm.videoUploaded) {
          this.setState({
            isLoading: false,
            videoLinkUrl: res.subm.videoLinkUrl,
            ...res.subm,
          });
        } else {
          console.log(res.subm);
          this.setState(
            {
              isLoading: false,
              ...res.subm,
              notUploaded: true,
            },
            () => {
              console.log(this.state);
            }
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  renderHeader = () => {
    return (
      <div>
        <h2>Video Submission</h2>
      </div>
    );
  };
  renderContent = () => {
    if (this.state.isLoading) {
      <Spin />;
    }
    if (this.state.notUploaded) {
      return (
        <div>
          <h3>Video not uploaded yet for submission {this.state.title}</h3>
        </div>
      );
    }
    if (this.state.videoLinkUrl) {
      return (
        <VideoSubmissionForm
          loggedInUser={null}
          preloadedData={this.state}
          isAdmin={false}
          context={false}
        />
      );
    }
  };
  render() {
    return (
      <div
        style={{
          padding: "10px",
        }}
      >
        <Space direction="vertical">
          {this.renderHeader()}
          {this.renderContent()}
        </Space>
      </div>
    );
  }
}

export default withRouter(PublicVideoComponent);
